import { useState, useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Treatments } from '../components/Treatments';
import { Reviews } from '../components/Reviews';
import { Articles } from '../components/Articles';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
import { WhatsAppFloat } from '../components/WhatsAppFloat';
import { BookingModal } from '../components/BookingModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Home() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  useEffect(() => {
    // Test API connection
    const testApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('API Connected:', response.data.message);
      } catch (e) {
        console.error('API connection error:', e);
      }
    };
    testApi();
  }, []);

  const openBookingModal = () => {
    setIsBookingOpen(true);
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#F9F8F6]">
      {/* Grain texture overlay */}
      <div className="grain-overlay" />
      
      <Header onBookClick={openBookingModal} />
      <main>
        <Hero onBookClick={openBookingModal} />
        <About />
        <Treatments />
        <Articles limit={3} />
        <Reviews />
        <CTA onBookClick={openBookingModal} />
      </main>
      <Footer />
      <WhatsAppFloat />
      
      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </div>
  );
}
